<template>
    <div class="storeshipment_con">
        <div class="status-section">
            <div class="status-text">
                请切换包裹后确认收货，门店商品库存自动添加
            </div>
        </div>
        <div class="tabs-container">
            <div v-for="(item, index) in shipmentdata" :key="index" class="tab-item"
                :class="{ active: currentTab === index }" @click="currentTab = index">
                <span class="tab-text">包裹{{ textretun(index) }}</span>
                <div v-if="currentTab === index" class="active-line"></div>
            </div>
        </div>
        <div class="body_con">
            <div class="clone_pad">
                <div class="row">
                    <text class="label">快递公司：</text>
                    <div class="order-no-container">
                        <text class="value">{{ shipmentdata[currentTab]?.express_name || "" }}</text>
                    </div>
                </div>
                <div class="row">
                    <text class="label">快递单号：</text>
                    <div class="order-no-container">
                        <text class="value">{{ shipmentdata[currentTab]?.express_num || "" }}</text>
                        <div class="copy-btn" @click="copyOrderNo(shipmentdata[currentTab].express_num)">复制</div>
                    </div>
                </div>
            </div>
            <!-- 商品列表 -->
            <div class="goods-section">
                <div class="goods-item" v-for="(item, index) in shipmentdata[currentTab]?.shop_order_shipment_info"
                    :key="index">
                    <div class="goods-image">
                        <img :src="comapi.getImageUrl(item.shop_order_info.cover_image)" />
                    </div>
                    <div class="goods-info">
                        <div class="goods-name">{{ item.shop_order_info.product_name }}({{
                            item.shop_order_info.spec_name }})</div>
                        <div class="goods-spec">规格：{{ item.shop_order_info.unit }}</div>
                        <div class="goods-price-row">
                            <div class="goods-price">￥{{ item.shop_order_info.shop_purchase_price / 100 }}</div>
                            <div class="goods-quantity">x{{ item.shop_order_info.num }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sumberbut" v-if="shipmentdata[currentTab]?.status === 1" @click="received">
                确认收货
            </div>
            <div class="ok_status" v-else>已收货</div>

        </div>

    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import storeapi from "@/utils/api/store";
import comapi from "@/utils/api/com";
import { useRouter, useRoute } from 'vue-router';
import { showToast } from "vant";
const router = useRouter();
const route = useRoute();

const order_uuid = route.query.order_uuid || '';
const currentTab = ref(0);
const shipmentdata = ref([]);
onMounted(() => {
    getShipmentDetail()
});
const getShipmentDetail = () => {
    storeapi.getShipmentDetail({
        shop_order_uuid: order_uuid
    }).then(res => {
        if (res.code === 200) {
            shipmentdata.value = res.data || [];
        }
    });
};
//确认收获
const received = () => {
    storeapi.received({
        shipment_uuid: shipmentdata.value[currentTab.value].uuid
    }).then(res => {
        if (res.code === 200) {
            showToast('确认收货成功');
            shipmentdata.value[currentTab.value].status =2;
        }
    });
}
//复制单号
const copyOrderNo = async (uuid) => {
    try {
        await navigator.clipboard.writeText(uuid);
        showToast('复制成功');
    } catch (err) {
        console.error('复制失败:', err);
        showToast('复制失败，请手动复制');
    }
};
const textretun = (index) => {
    //返回中文数字
    const num = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
    return num[index] || '';
};
</script>
<style lang="less" scoped>
.storeshipment_con {
    height: 100vh;
    overflow:auto;

    .status-section {
        background-color: rgba(220, 187, 137, 0.15);
        padding: 13px;
        text-align: center;

        .status-text {
            font-size: 13px;
            font-weight: bold;
            color: #3C211F;
        }
    }

    .tabs-container {
        display: flex;
        background: #fff;
        overflow-x: auto;
        padding: 0 10px;
        border-bottom: 1px solid transparent;
        width: 100%; // 确保占满宽度

        // 隐藏滚动条
        &::-webkit-scrollbar {
            display: none;
        }

        .tab-item {
            position: relative;
            padding: 13px 8px;
            white-space: nowrap;
            font-size: 15px;
            color: #999;
            cursor: pointer;

            &.active {
                color: #DCBB89;
                font-weight: 600;
            }

            .active-line {
                position: absolute;
                bottom: 8px;
                left: 50%;
                transform: translateX(-50%);
                width: 20px;
                height: 3px;
                background-color: #dcb36d;
                border-radius: 2px;
            }
        }
    }

    .body_con {
        padding: 10px 17px;

        .clone_pad {
            background-color: #fff;
            padding: 10px;
            border-radius: 8px;
        }
        .sumberbut{
            background: #DCBB89;
            border-radius: 11px;
            height: 46px;
            width: 100%;
            text-align: center;
            font-size: 18px;
            color: #fff;
            line-height: 46px;
            margin-top: 20px;
        }
        .ok_status{
            font-size: 13px;
            font-weight: bold;
            color: #888;
            margin-top: 10px;
            text-align: center;
        }
        .goods-section {
            margin-top: 10px;
            background-color: #fff;
            padding: 16px;
            margin-bottom: 10px;
            border-radius: 8px;

            .goods-item {
                display: flex;
                margin-bottom: 16px;

                .goods-image {
                    width: 80px;
                    height: 80px;
                    margin-right: 12px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 4px;
                    }
                }

                .goods-info {
                    flex: 1;

                    .goods-name {
                        font-size: 14px;
                        color: #333;
                        margin-bottom: 4px;
                    }

                    .goods-spec {
                        font-size: 12px;
                        color: #999;
                        margin-bottom: 8px;
                    }

                    .goods-price-row {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .goods-price {
                            font-size: 16px;
                            color: #ff7123;
                            font-weight: bold;
                        }

                        .goods-quantity {
                            font-size: 14px;
                            color: #666;
                        }
                    }
                }
            }
        }

        .order-no-container {
            display: flex;
            align-items: center;
        }

        .row {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            font-size: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            .label {
                color: #333;
                width: 75px;
            }

            .value {
                color: #333;
                flex: 1;
            }

            .copy-btn {
                border: 1px solid #CCC;
                color: #666;
                font-size: 15px;
                height: 25px;
                line-height: 25px;
                width: 50px;
                border-radius: 4px;
                margin-left: 10px;
                text-align: center;
            }
        }
    }
}
</style>